module.exports = __webpack_public_path__ + "static/media/7.bd0fb520.webp";